/* eslint no-undef: 0 */
/* eslint no-empty: 0 */

function fomatEvent(title) {
  return JSON.stringify({
    type: 'navStateChange',
    navState: {
      url: `${document.location.protocol}//${document.location.host}${document.location.pathname}`,
      title: title || document.title
    }
  })
}

async function postMessage(message) {
  if (window.webView) {
    // Android
    window.webView.postMessage(message)
  } else {
    // iOS/other
    window.postMessage(message, '*')
  }
}

async function updateNavState(title) {
  setTimeout(() => postMessage(fomatEvent(title)), 50)
}

try {
  const { history } = window
  const { pushState, back } = history

  postMessage(JSON.stringify({
    type: 'cookie',
    cookie: document.cookie
  }), '*')

  history.pushState = function (...rest) {
    updateNavState()
    return pushState.apply(history, rest)
  }

  history.back = function () {
    updateNavState()
    return back.apply(history)
  }

  window.onload = function () {
    updateNavState()
  }

  window.onpopstate = function () {
    updateNavState()
  }

  window.onhashchange = function () {
    updateNavState()
  }
} catch (error) {
}


try {
  new MutationObserver(function (mutations) {
    updateNavState(mutations[0].target.text)
  }).observe(
    document.querySelector('title'), {
      attributes: true,
      childList: true
    }
  )

  new WebKitMutationObserver(function (mutations) {
    updateNavState(mutations[0].target.text)
  }).observe(
    document.querySelector('title'), {
      attributes: true,
      childList: true
    }
  )
} catch (error) {}

export default 1
